var pako = require('pako');
let CryptoJS = require('crypto-js')

import { DEFAULT_PASSWORD } from './const'

// Metodo  encriptar: 
// 1. Comprimi o JSON stringify dos dados
// 2. Encripta com o AES
// 3. Comprimi com o PAKO (npm lib) apos encriptar 

// Metodo  desincriptar: 
// 1. Descrompimi os dados antes de descriptar
// 2. desncripta com o AES
// 3. desncripta com o PAKO (npm lib) apos descripitar 


function compressData(cc_attr) {
    let compressed = pako.deflate(JSON.stringify(cc_attr), { to: 'string' });
        //USE AES TO ENCRPT
    let data_enc = CryptoJS.AES.encrypt(compressed, DEFAULT_PASSWORD).toString();
    let data_enc_compressed = pako.deflate(data_enc, { to: 'string' })
    return data_enc_compressed
}
// console.log('#6 ', pako.deflate(data_enc,{ to: 'string' } ));


////USE AES TO DEC
//decompress 
function decompressData(data_enc_compressed) {
    let data_enc_decompressed = pako.inflate(atob(data_enc_compressed), { to: 'string' });
    // console.log('Data decompressed ', data_enc_decompressed);
    let data_descripted = CryptoJS.AES.decrypt(data_enc_decompressed, DEFAULT_PASSWORD);
    var ret_1 = data_descripted.toString(CryptoJS.enc.Utf8);
    let ret_2 = pako.inflate(ret_1, { to: 'string' });
    return JSON.parse(ret_2);
}


export { compressData, decompressData }